(function () {
    angular.module('PWAPoCApp').constant('appVersion', '2026.4.21');
})();
